module.exports = __webpack_public_path__ + "f5d4d8af690c073df1fa55cddc678596.png";